import React from "react";
import { usePcpLiveLessonContext } from "../../store";
import { UnsupportedPlatformPage } from "./UnsupportedPlatformPage";
import { UnsupportedBrowserPage } from "./UnsupportedBrowserPage";
import { UnsupportedBrowserVersionPage } from "./UnsupportedBrowserVersionPage";
import { UnsupportedEnvironmentUnspecifiedPage } from "./UnsupportedEnvironmentUnspecifiedPage";
import { Environment, EnvironmentInfo } from '@azure/communication-calling';

/** Shows page with unsupported environment reason. */
export const UnsupportedEnvironmentPage = (props: {
    environment?: Environment,
    envInfo: EnvironmentInfo | undefined
}): JSX.Element => {
    const { envInfo } = props;

    if (envInfo !== undefined && envInfo !== null)
    {
        if (!envInfo.isSupportedPlatform) {
            return <UnsupportedPlatformPage />
        } else if (!envInfo.isSupportedBrowser) {
            return <UnsupportedBrowserPage />
        } else if (!envInfo.isSupportedBrowserVersion) {
            return <UnsupportedBrowserVersionPage />
        }
    }

    return <UnsupportedEnvironmentUnspecifiedPage />
}